import { routerChange } from '@/services/router'
import { invalidateAuthentication } from './auth-state'
import { readCollaborationLoginQuery, resolveCollaborationReturnUrl, isPasswordLoginEntry } from './session'
import { loginTenantScope } from '@/services/utils/tenantScope'

let navigation: Promise<void> | undefined

export function openAuthenticationGateway(returnUrl = location.href, options: { authorize?: boolean } = {}): Promise<void> {
    if (navigation) return navigation
    const path = new URL(location.href).hash.split('?')[0]
    if (['', '#', '#/', '#/packageLogin/pages/session/index'].includes(path)) {
        return Promise.resolve()
    }
    const query = readCollaborationLoginQuery(new URL(returnUrl, location.origin).href)
    const target = resolveCollaborationReturnUrl(query.get('redirect') || returnUrl)
    invalidateAuthentication()
    const params: Record<string, string> = { redirect: target }
    const tenantId = query.get('tenantId') || loginTenantScope.currentTenantId
    if (tenantId) params.tenantId = tenantId
    if (options.authorize) params.loginIntent = 'authorize'
    else if (isPasswordLoginEntry(new URL(returnUrl, location.origin).href)) params.loginIntent = 'password'
    const task = routerChange('reLaunch', 'packageLogin', 'session', params)
        .finally(() => { if (navigation === task) navigation = undefined })
    navigation = task
    return task
}
